var _rect, _path, _path2, _g, _circle, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNoAccess = function SvgNoAccess(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 288,
    viewBox: "0 0 383 288",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 16,
    width: 256,
    height: 256,
    rx: 72,
    fill: "#E8F0FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195 102.333c-23 0-41.667 18.667-41.667 41.667S172 185.667 195 185.667 236.667 167 236.667 144 218 102.333 195 102.333zm0 75c-18.417 0-33.333-14.916-33.333-33.333a32.932 32.932 0 0 1 7.041-20.417l46.709 46.709A32.932 32.932 0 0 1 195 177.333zm26.292-12.916-46.709-46.709A32.932 32.932 0 0 1 195 110.667c18.417 0 33.333 14.916 33.333 33.333a32.932 32.932 0 0 1-7.041 20.417z",
    fill: "#196AE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.092 227.969a1 1 0 0 1 1.816 0l5.065 10.979a1 1 0 0 0 .79.575l12.007 1.423a1 1 0 0 1 .562 1.728l-8.878 8.209a1 1 0 0 0-.302.929l2.357 11.86a1 1 0 0 1-1.47 1.067l-10.55-5.906a1 1 0 0 0-.977 0l-10.551 5.906a1 1 0 0 1-1.47-1.067l2.357-11.86a1 1 0 0 0-.302-.929l-8.877-8.209a1 1 0 0 1 .56-1.728l12.008-1.423a1 1 0 0 0 .79-.575l5.065-10.979z",
    fill: "#FF6D00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#by1eves9ua)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.5 180v-7c0-9.66-7.84-17.5-17.5-17.5s-17.5 7.84-17.5 17.5v7H297v49h56v-49h-10.5zm-28-7c0-5.81 4.69-10.5 10.5-10.5s10.5 4.69 10.5 10.5v7h-21v-7zm31.5 49h-42v-35h42v35zm-21-10.5c3.85 0 7-3.15 7-7s-3.15-7-7-7-7 3.15-7 7 3.15 7 7 7z",
    fill: "#196AE5",
    fillOpacity: 0.3
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 67,
    cy: 67,
    r: 43,
    stroke: "#EF6C00",
    strokeWidth: 16
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "by1eves9ua"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(283 152)",
    d: "M0 0h84v84H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoAccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noAccess.2a1b6e70.svg";
export { ForwardRef as ReactComponent };